import { c as _c } from "react/compiler-runtime";
import React, { useContext, useEffect, useState } from "react";
import styles from "./DKGavebrevTaxWidget.module.scss";
import { DKGavebrevTaxBarChart } from "./DKGavebrevTaxBarChart";
import { EffektButton, EffektButtonVariant } from "../../../shared/components/EffektButton/EffektButton";
import { EffektTextInput } from "../../../shared/components/EffektTextInput/EffektTextInput";
import { WidgetContext } from "../../layout/layout";
import { HorizontalDKGavebrevTaxBarChart } from "./DKGavebrevTaxBarChartHorizontal";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import { usePlausible } from "next-plausible";
import { thousandize } from "../../../../util/formatting";
export const DKGavebrevTaxWidget: React.FC<{
  title: string;
  description: string;
  incomeLabel?: string;
  donationLabel?: string;
  defaultIncome: number;
  defaultDonation: number;
  resultDescriptionTemplate?: string;
  buttonText?: string;
  chartLabels?: {
    maximumDeduction?: string;
    yourDonation?: string;
    yourTaxBenefit?: string;
  };
  locale: string;
}> = t0 => {
  const $ = _c(83);
  const {
    title,
    description,
    incomeLabel,
    donationLabel,
    defaultIncome,
    defaultDonation,
    resultDescriptionTemplate,
    buttonText,
    chartLabels,
    locale
  } = t0;
  const plausible = usePlausible();
  let t1;
  if ($[0] !== defaultIncome) {
    t1 = defaultIncome.toString();
    $[0] = defaultIncome;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [income, setIncome] = useState(t1);
  let t2;
  if ($[2] !== defaultDonation) {
    t2 = defaultDonation.toString();
    $[2] = defaultDonation;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [donation, setDonation] = useState(t2);
  const [lastValidIncome, setLastValidIncome] = useState(defaultIncome);
  const [lastValidDonation, setLastValidDonation] = useState(defaultDonation);
  const [widgetContext, setWidgetContext] = useContext(WidgetContext);
  const isMobile = useIsMobile();
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [0.01, 0.05, 0.1];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const suggestedPercentages = t3;
  let t4;
  let t5;
  if ($[5] !== income || $[6] !== locale) {
    t4 = () => {
      if (income === "") {
        setLastValidIncome(0);
        return;
      }
      const incomeNumber = Number(income.replace(/\D/g, ""));
      if (!isNaN(incomeNumber)) {
        setLastValidIncome(incomeNumber);
        const formattedIncome = thousandize(incomeNumber, locale);
        if (formattedIncome !== income) {
          setIncome(formattedIncome);
        }
      }
    };
    t5 = [income, locale];
    $[5] = income;
    $[6] = locale;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[9] !== donation || $[10] !== locale) {
    t6 = () => {
      if (donation === "") {
        setLastValidDonation(0);
        return;
      }
      const donationNumber = Number(donation.replace(/\D/g, ""));
      if (!isNaN(donationNumber)) {
        setLastValidDonation(donationNumber);
        const formattedDonation = thousandize(donationNumber, locale);
        if (formattedDonation !== donation) {
          setDonation(formattedDonation);
        }
      }
    };
    t7 = [donation, locale];
    $[9] = donation;
    $[10] = locale;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  useEffect(t6, t7);
  const maximumDeduction = lastValidIncome * 0.92 * 0.15;
  const effectiveDonation = Math.min(lastValidDonation, maximumDeduction);
  const taxBenefit = effectiveDonation * 0.26;
  let t8;
  if ($[13] !== chartLabels || $[14] !== isMobile || $[15] !== lastValidDonation || $[16] !== locale || $[17] !== maximumDeduction || $[18] !== taxBenefit) {
    t8 = !isMobile && <DKGavebrevTaxBarChart maximumDeduction={maximumDeduction} donation={lastValidDonation} taxBenefit={taxBenefit} labels={chartLabels} locale={locale} />;
    $[13] = chartLabels;
    $[14] = isMobile;
    $[15] = lastValidDonation;
    $[16] = locale;
    $[17] = maximumDeduction;
    $[18] = taxBenefit;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <div className={styles.desktopChart}>{t8}</div>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== title) {
    t10 = <h5>{title}</h5>;
    $[22] = title;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== description) {
    t11 = <p>{description}</p>;
    $[24] = description;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== chartLabels || $[27] !== isMobile || $[28] !== lastValidDonation || $[29] !== locale || $[30] !== maximumDeduction || $[31] !== taxBenefit) {
    t12 = isMobile && <HorizontalDKGavebrevTaxBarChart maximumDeduction={maximumDeduction} donation={lastValidDonation} taxBenefit={taxBenefit} labels={chartLabels} locale={locale} />;
    $[26] = chartLabels;
    $[27] = isMobile;
    $[28] = lastValidDonation;
    $[29] = locale;
    $[30] = maximumDeduction;
    $[31] = taxBenefit;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t12) {
    t13 = <div className={styles.mobileChart}>{t12}</div>;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  const t14 = incomeLabel ?? "Indkomst f\xF8r skat";
  let t15;
  if ($[35] !== t14) {
    t15 = <label htmlFor="income-input">{t14}:</label>;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = val => {
      setIncome(val);
    };
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== income) {
    t17 = <EffektTextInput value={income} name="income-input" type="tel" placeholder="0" onChange={t16} denomination="kr" variant="underlined" />;
    $[38] = income;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t15 || $[41] !== t17) {
    t18 = <div className={styles.input}>{t15}{t17}</div>;
    $[40] = t15;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== lastValidDonation || $[44] !== lastValidIncome || $[45] !== locale || $[46] !== plausible) {
    t19 = <div className={styles.suggestedPercentages}>{suggestedPercentages.map(percentage => {
        const suggestedAmount = Math.round(lastValidIncome * percentage);
        const isSelected = lastValidDonation === suggestedAmount && suggestedAmount > 0;
        return <EffektButton key={percentage} onClick={() => {
          plausible("GavebrevTaxWidgetSelectPercentage", {
            props: {
              page: window.location.pathname,
              percentage: percentage * 100,
              amount: suggestedAmount
            }
          });
          setDonation(thousandize(suggestedAmount, locale));
        }} variant={EffektButtonVariant.SECONDARY} selected={isSelected} style={{
          fontSize: "0.9rem"
        }} squared={true}>{(percentage * 100).toFixed(0)}%</EffektButton>;
      })}</div>;
    $[43] = lastValidDonation;
    $[44] = lastValidIncome;
    $[45] = locale;
    $[46] = plausible;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  const t20 = donationLabel ?? "Donation";
  let t21;
  if ($[48] !== t20) {
    t21 = <label htmlFor="donation-input">{t20}:</label>;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = val_0 => {
      setDonation(val_0);
    };
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== donation) {
    t23 = <EffektTextInput value={donation} name="donation-input" type="tel" placeholder="0" onChange={t22} denomination="kr" variant="underlined" />;
    $[51] = donation;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t21 || $[54] !== t23) {
    t24 = <div className={styles.input}>{t21}{t23}</div>;
    $[53] = t21;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t18 || $[57] !== t19 || $[58] !== t24) {
    t25 = <div className={styles.inputs}>{t18}{t19}{t24}</div>;
    $[56] = t18;
    $[57] = t19;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== lastValidDonation || $[61] !== lastValidIncome || $[62] !== locale || $[63] !== maximumDeduction || $[64] !== resultDescriptionTemplate || $[65] !== taxBenefit) {
    t26 = resultDescriptionTemplate && maximumDeduction > 0 && <p>{resultDescriptionTemplate.replace("{income}", thousandize(lastValidIncome, locale)).replace("{maxDeduction}", thousandize(maximumDeduction, locale)).replace("{donation}", thousandize(lastValidDonation, locale)).replace("{taxBenefit}", thousandize(taxBenefit, locale))}</p>;
    $[60] = lastValidDonation;
    $[61] = lastValidIncome;
    $[62] = locale;
    $[63] = maximumDeduction;
    $[64] = resultDescriptionTemplate;
    $[65] = taxBenefit;
    $[66] = t26;
  } else {
    t26 = $[66];
  }
  let t27;
  if ($[67] !== buttonText || $[68] !== lastValidDonation || $[69] !== plausible || $[70] !== setWidgetContext || $[71] !== widgetContext) {
    t27 = buttonText && <div className={styles.cta}><EffektButton onClick={() => {
        plausible("OpenDonationWidget", {
          props: {
            page: window.location.pathname
          }
        });
        plausible("OpenDonationWidgetGavebrevTaxWidgetCTA", {
          props: {
            page: window.location.pathname,
            donation: lastValidDonation
          }
        });
        setWidgetContext({
          ...widgetContext,
          open: true,
          prefilledSum: lastValidDonation
        });
      }} variant={EffektButtonVariant.PRIMARY} style={{
        padding: "0.75rem 3rem"
      }}>{buttonText}</EffektButton></div>;
    $[67] = buttonText;
    $[68] = lastValidDonation;
    $[69] = plausible;
    $[70] = setWidgetContext;
    $[71] = widgetContext;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== t10 || $[74] !== t11 || $[75] !== t13 || $[76] !== t25 || $[77] !== t26 || $[78] !== t27) {
    t28 = <div className={styles.description}>{t10}{t11}{t13}{t25}{t26}{t27}</div>;
    $[73] = t10;
    $[74] = t11;
    $[75] = t13;
    $[76] = t25;
    $[77] = t26;
    $[78] = t27;
    $[79] = t28;
  } else {
    t28 = $[79];
  }
  let t29;
  if ($[80] !== t28 || $[81] !== t9) {
    t29 = <div className={styles.wrapper}><div className={styles.container}>{t9}{t28}</div></div>;
    $[80] = t28;
    $[81] = t9;
    $[82] = t29;
  } else {
    t29 = $[82];
  }
  return t29;
};